import * as t from 'io-ts';

export const ProductProjectC = t.type({
  id: t.number,
  description: t.string,
  orderNumber: t.string,
});
export type ProductProject = t.TypeOf<typeof ProductProjectC>;
